import {
  typesOptions,
  statusesOptions,
  categoriesOptions,
  publicOptions,
  visibleOptions,
} from './label-config'
import { parseTime } from '@/filters'
import { TableColumnType } from './label-type'
import type { GetTagListParams } from '@/api/material_label/type'
import type { SearchListType } from './label-type'

export const formValueSearch: SearchListType[] = [
  {
    label: '标签值id:',
    prop: 'id',
    type: 'input',
    subtype: 'number',
    params: {
      min: 0,
      max: 9223372036854775807,
    },
  },
  {
    label: '标签状态:',
    type: 'select',
    prop: 'statuses',
    params: {
      multiple: true,
      'collapse-tags': true,
      clearable: true,
      options: statusesOptions,
    },
  },
  {
    label: '标签组分类:',
    type: 'select',
    prop: 'categories',
    params: {
      disabled: true,
      multiple: true,
      options: categoriesOptions,
    },
  },
  {
    label: '元素类型:',
    type: 'select',
    prop: 'element_types',
    params: {
      multiple: true,
      'collapse-tags': true,
      clearable: true,
      options: typesOptions,
    },
  },
  {
    label: '是否公开:',
    type: 'select',
    prop: 'public',
    params: {
      clearable: true,
      options: publicOptions,
    },
  },
]

export const formGroupSearch: SearchListType[] = [
  {
    label: '标签组id',
    prop: 'id',
    type: 'input',
    subtype: 'number',
    params: {
      min: 0,
      max: 9223372036854775807,
    },
  },
  {
    label: '标签组分类:',
    type: 'select',
    prop: 'categories',
    params: {
      disabled: true,
      multiple: true,
      options: categoriesOptions,
    },
  },
  {
    label: '元素类型:',
    type: 'select',
    prop: 'element_types',
    params: {
      multiple: true,
      'collapse-tags': true,
      clearable: true,
      options: typesOptions,
    },
  },
  {
    label: '可见范围:',
    type: 'select',
    prop: 'visibles',
    params: {
      options: visibleOptions,
    },
  },
]

export const formValueQuery: GetTagListParams = {
  id: '',
  group_id: '',
  name: '',
  order: '-updated_time',
  keyWords: '',
  categories: [2],
  public: '',
  statuses: [],
  element_types: [],
  visibles: '',
  level: '',
  page: 1,
  page_size: 15,
}

export const formValueColumn: TableColumnType[] = [
  {
    prop: 'select-cell',
    slot: 'select-cell',
  },
  {
    label: '标签ID',
    prop: 'id',
    width: 80,
    align: 'center',
  },
  {
    label: '标签组',
    prop: 'group_name',
    align: 'center',
  },
  {
    label: '标签名称',
    prop: 'name',
    slot: 'name',
  },
  {
    prop: 'action-cell',
    slot: 'action-cell',
  },
  {
    prop: 'icon_url',
    slot: 'icon_url',
    showOverflowTooltip: true,
  },
  {
    label: '标签状态',
    prop: 'status',
    align: 'center',
    params: {
      innerHTML(o: any) {
        const { row } = o
        switch (row.status) {
          case 1:
            return '待启用'
          case 2:
            return '使用中'
          case 3:
            return '已废弃'
          default:
            return '-'
        }
      },
    },
  },
  {
    label: '更新人',
    prop: 'modifier_name',
    align: 'center',
  },
  {
    label: '更新时间',
    prop: 'updated_time',
    sortable: 'updated_time',
    width: 150,
    align: 'center',
    params: {
      innerHTML(o: any) {
        const { row } = o
        return parseTime(row.updated_time, '{y}-{m}-{d} {h}:{i}:{s}')
      },
    },
  },
]
